<template>
  <div>
    <!-- 班级积分小组页面----添加小组->小组所属班级 -->
    <!--用于列表页查看关联的数据,不做关联选择操作-->
    <el-table :data="datas" v-if="!qIsRelation" v-loading="loading" :element-loading-text="loadingText" border
      highlight-current-row style="width: 100%" max-height="300px" ref="gradeList1"
      :header-cell-style="{ background: '#f5f7fa' }" @select="itemHandleSelectionChange">
      <el-table-column type="selection" width="55" align="center" v-if="qIsRelation" :show-overflow-tooltip="true"></el-table-column>
      <!-- <el-table-column
        align="center"
        label="编号"
        prop="id"
        width="80"
        :show-overflow-tooltip="true"
      ></el-table-column>-->
      <el-table-column :show-overflow-tooltip="true" align="center" label="班级名称" prop="gradeName"
        inputSearch="true"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="center" label="课程标题" prop="openCourseTitle"
        inputSearch="true"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="center" label="容纳人数" prop="limitNumber" width="150"
        inputSearch="true"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" align="center" label="班主任" prop="headTeacherName" width="150"
        inputSearch="true">
        <template slot="header" slot-scope="scope">
          <el-popover placement="bottom-start" trigger="click" ref="popover1">
            <div slot="reference" class="search-header">
              <span class="search-title">班主任</span>
              <i class="search-icon el-icon-search"></i>
            </div>
            <div class="searchbar">
              <!-- 第一处：表头筛选 -->
              <el-select filterable remote :remote-method="remoteTeacherSearch" :loading="teacherLoading" v-model="HeadTeacherId" placeholder="请选择班主任" @change="teacherChange" clearable>
                <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </div>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <span v-if="scope.row.headTeacherName">
            {{ scope.row.headTeacherName }}
          </span>
          <span v-else class="gray">未设置</span>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" width="160" align="center" label="创建时间" prop="createTime"
        inputSearch="true"></el-table-column>
    </el-table>
    <!--用于父组件中展示的UI-->
    <el-row v-if="qIsRelation && !ExamAndHomeworkCreate">
      <el-col :span="span">
        <el-button v-if="maxSelectedCount != 1 || isMultiple" :style="{ width: styleWidth > 0 ? styleWidth + 'px' : '' }"
          :plain="true" @click="openDialog" class="live_btn">
          <i class="el-icon-plus"></i>
          &nbsp;&nbsp;{{
            selectIds.length > 0
            ? "已关联(" + (selectIds.length == 1 ? selectionAll[0]?.title || selectionAll[0]?.name : selectIds.length) + ")个班级"
            : "点击关联"
          }}
        </el-button>
        <el-button v-if="maxSelectedCount == 1 && !isMultiple" :style="{ width: styleWidth > 0 ? styleWidth + 'px' : '' }"
          :plain="true" @click="openDialog" class="live_btn relation-btn-nwarp">
          <i class="el-icon-plus"></i>
          &nbsp;&nbsp;{{
            selectIds.length > 0 && selectionAll.length > 0
            ? "已关联(" +
            (selectionAll[0]?.title || selectionAll[0]?.name) +
            ")班级"
            : "点击关联"
          }}
        </el-button>
      </el-col>
      <!-- <el-popover placement="bottom"
                  :title="tipRelationTitle"
                  :width="330"
                  trigger="click">
        <div>
          {{ `最多只能关联${maxSelectedCount}个班级` }}
        </div>
        <template #reference>
          <el-button><i class="el-icon-question"></i> 说明
            <i class="el-icon-caret-bottom"></i>
          </el-button>
        </template>
      </el-popover>-->
    </el-row>
    <span v-else>
      <el-button v-if="maxSelectedCount != 1" :style="{ width: styleWidth > 0 ? styleWidth + 'px' : '' }" :plain="true"
        @click="openDialog" class="live_btn">
        <i class="el-icon-plus"></i>
        &nbsp;&nbsp;{{
          selectIds.length > 0
          ? "已关联(" + selectIds.length + ")个班级"
          : "点击关联"
        }}
      </el-button>
      <div class="date_List" v-if="selectTimeAry != null && selectTimeAry.length > 0 && !classDialog">
        <span class="fl"></span>
        <div class="tag_list clearfix fl height">
          <el-tag style="width: 380px" closable v-for="(tag, index) in selectTimeAry" :key="index"
            @close="delStudentList(index, selectTimeAry)" size="medium">{{ index + 1 }}、{{ tag }}</el-tag>
        </div>
      </div>
    </span>

    <el-dialog :visible.sync="listDialog" :close-on-click-modal="false" :fullscreen="false" v-if="qIsRelation"
      :title="tipRelationTitle" width="850px" append-to-body v-dialogDrag top="18vh" :before-close="closeDialogClass">
      <el-row style="margin: -30px 0 10px 0">
        <el-col :span="6">
          <el-input :width="200" v-model="keyword" placeholder="可按班级查找" clearable></el-input>
        </el-col>
        <el-button type="primary" @click="getDatas" plain>
          <i class="search-icon el-icon-search"></i>&nbsp;搜索
        </el-button>
      </el-row>

      <div class="dTable">
        <el-table :data="datas" ref="gradeList" border highlight-current-row style="width: 100%" height="300px"
          :header-cell-style="{ background: '#f5f7fa' }" v-loading="loading" :element-loading-text="loadingText"
          @select="itemHandleSelectionChange">
          <el-table-column type="selection" width="55"  align="center" ></el-table-column>
          <!-- <el-table-column
            align="center"
            label="编号"
            :show-overflow-tooltip="true"
            prop="id"
            width="80"
          ></el-table-column>-->
          <el-table-column :show-overflow-tooltip="true" align="left" label="班级名称" prop="gradeName" inputSearch="true"
            width="160"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="left" label="课程标题" prop="openCourseTitle"
            inputSearch="true">
            <template slot-scope="scope">
              <span v-if="scope.row.openCourseTitle">
                {{
                  scope.row.openCourseTitle
                }}
              </span>
              <span v-else class="gray">未填写</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" label="容纳人数" prop="limitNumber" width="100"
            inputSearch="true"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" label="班主任" prop="headTeacherName" width="120"
            inputSearch="true">
            <template slot="header" slot-scope="scope">
              <el-popover placement="bottom-start" trigger="click" ref="popover1">
                <div slot="reference" class="search-header">
                  <span class="search-title">班主任</span>
                  <i class="search-icon el-icon-search"></i>
                </div>
                <div class="searchbar">
                  <!-- 第二处：弹窗内筛选 -->
                  <el-select filterable remote :remote-method="remoteTeacherSearch" :loading="teacherLoading" v-model="HeadTeacherId" placeholder="请选择班主任" @change="teacherChange" clearable>
                    <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key"></el-option>
                  </el-select>
                </div>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.headTeacherName">
                {{ scope.row.headTeacherName }}
              </span>
              <span v-else class="gray">未设置</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" width="160" align="center" label="创建时间" prop="createTime"
            inputSearch="true"></el-table-column>
        </el-table>
      </div>
      <p class="choose_bom">
        <span style="margin-right: 10px" v-if="selectIds.length > 0">
          已选择[
          <b class="select_red" style="font-size: 16px">
            {{
              selectionClassList(selectionAll)
            }}
          </b>
          ]{{ selectionAll.length > 1 ? "个" : "" }}班级
        </span>
        <span style="margin-right: 10px" v-else>请先选择班级</span>
        <el-button size="medium" style="font-size: 16px; float: right" type="primary" @click="clickTrue"
        >确定</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { timeFormatNew, isNull } from "common/utils";
import { GetGradeNoPageDtos } from "network/teachClass";
import { timeFormat } from "common/utils";
import { ValidDailySchedule } from "network/teachDailySchedule";
import { getAdminList } from "network/administrator";
export default {
  name: "ClassList",
  props: {
    ids: {
      type: Array,
      default: () => []
    },
    sections: {
      type: Array
    },
    isEdit: {
      type: Boolean
    },
    section: {
      type: Object
    },
    dailyScheduleInfo: {
      type: Object
    },
    span: {
      type: Number,
      default: 6.5
    },
    pageSize: {
      type: Number,
      default: 50
    },
    //能勾选的最大数量
    maxSelectedCount: {
      type: Number,
      default: 1
    },
    isRelation: {
      type: Boolean,
      default: false
    },
    //是否返回对象{id,title}，默认返回id
    isReturnObj: {
      type: Boolean,
      default: false
    },
    // 创建考试作业私有属性，班级考试记录也用上了
    ExamAndHomeworkCreate: {
      type: Boolean,
      default: false
    },
    // 父组件展示宽度
    styleWidth: {
      type: Number,
      default: 0
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    // 班级考试记录使用
    classDialog:{
      type: Boolean,
      default: false
    }
  },
  created() {
    // sections.length==0  && isEdit == false? true : false
    // if(this.sections.length ==0 && this.isEdit == false && (isNull(this.dailyScheduleInfo.category)||this.dailyScheduleInfo.category==0)){
    //   this.statu = true
    // }else{
    //   this.statu = false
    // }
    // if (this.selectIds.length > 0) {
    // }
    // this.getDatas();
    if(this.classDialog){
      this.listDialog = true;
    }
    this.getTeacherList();
  },
  data() {
    return {
      loading: false, //加载状态开关
      loadingText: "loading...", //加载状态提示文本
      qIsRelation: this.isRelation,
      keyword: "",
      listDialog: false,
      datas: new Array(),
      selectIds: this.ids,
      isSelectLoad: false,
      tipRelationTitle: "关联班级",
      selectTimeAry: [],
      classData: "",
      // 选中数组
      selectionAll: [],
      statu: false,
      HeadTeacherId: null,
      options: [],
      adminList: [],
      classDialogRow:{},
      teacherLoading: false
    };
  },
  watch: {
    ids: {
      handler(newVal, oldVal) {
        // if (!newVal || !Array.isArray(newVal)) return false;
        // if (JSON.stringify(newVal) == JSON.stringify(this.selectIds))
        //   return false;
        this.selectIds = newVal;
        if (this.datas.length == 0) {
          this.getDatas();
        }
      },
      immediate: true,
      deep: true
    },
    selectTimeAry: {
      handler(newVal, oldVal) {
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    // 获取管理员身份
    AdminCache() {
      return (
        this.$store.state.AdminCache || sessionStorage.getItem("AdminCache")
      );
    },
  },
  methods: {
    // 删除标签
    delStudentList(index, valAll) {
      let classData = [];
      let length = valAll[index].indexOf("（");
      let name = valAll[index].slice(0, length);
      this.datas.map(item => {
        if (item.name == name) {
          let length1 = this.selectIds.indexOf(item.gradeId);
          this.selectIds.splice(length1, 1);
          this.$refs.gradeList.toggleRowSelection(item, false);
        }
        // 获取其余选中的班级数据
        if (this.selectIds && this.selectIds.length > 0) {
          this.selectIds.map(item1 => {
            if (item1 != item.gradeId) {
              if (item.students && item.students.length != 0) {
                classData.push(...item.students);
              }
            }
          });
        }
      });
      valAll.splice(index, 1);
      this.$emit("changedCallback", classData, "delete");
      this.$message({ message: "删除成功！", type: "success" });
    },
    // 选择组件  --- 确定按钮
    clickTrue() {
      if (this.selectIds.length > 0) {
        this.listDialog = false;
        // 班级考试记录页
        if(this.classDialog){
          this.$emit("changedCallback1", this.classDialogRow);
        }
      } else {
        this.$message.warning("请先选择班级");
      }
    },
    // el-select remote 搜索回调，query 对应关键字 keyWord
    remoteTeacherSearch(query) {
      this.getTeacherList(query);
    },
    // 获取老师列表（可传入关键字 keyWord）
    async getTeacherList(keyWord = "") {
      this.teacherLoading = true;
      const config = sessionStorage.getItem("allConfig")
        ? JSON.parse(sessionStorage.getItem("allConfig"))
        : {};
      let data = {
        ids: [],
        keyWord: keyWord || "",
        pageSize: 0,
        adminTypeIds: [config ? config.businessRoleId : 1038]
      };
      const res = await getAdminList(data);
      this.teacherLoading = false;
      if (res && res.code && res.code == 0) {
        this.$alert(res.message);
        return false;
      } else {
        this.adminList = res.result;
      }
      let arr = [];
      if (!isNull(this.adminList)) {
        res.result.forEach(item => {
          arr.push({ key: item.id, value: item.name });
        });
        this.options = [{ key: "0", value: "全部" }, ...arr];
      } else {
        this.options = [{ key: "0", value: "全部" }];
      }
    },
    teacherChange(val) {
      this.HeadTeacherId = val
      this.getDatas()
    },
    async getDatas() {
      var that = this;
      if (!that.qIsRelation) {
        that.pageSize = 0;
      }
      that.loading = true;
      var obj = {
        GradeIds: this.selectIds,
        GradeName: this.keyword,
        PageSize: that.pageSize,
        HeadTeacherId: this.HeadTeacherId
      }
      const res = await GetGradeNoPageDtos(obj);
      that.loading = false;
      if (res.code == 0) {
        that.$alert(res.message);
        return false;
      }
      let rows = res.result;
      if (rows && rows.length > 0) {
        rows.forEach(
          item =>
            (item.createTime = timeFormat(item.createTime, "yyyy-MM-dd hh:mm"))
        );
      }
      var objs = [];
      // if (this.selectIds.length == 1) {
      //   // 只有一个选中参数
      //   objs.push({
      //     id: rows[0].gradeId,
      //     title: rows[0].gradeName,
      //     students: rows[0].students,
      //     type: "class"
      //   });
      // } else if (this.selectIds.length > 1) {
      rows.map(item => {
        if (this.selectIds.indexOf(item.gradeId) != -1) {
          objs.push({
            id: item.gradeId,
            title: item.gradeName,
            students: item.students,
            type: "class"
          });
        }
      });
      // }
      this.selectionAll = Array.from(new Set(objs));
      that.datas = rows;
      if (that.$refs.gradeList && that.qIsRelation == true) {
        setTimeout(function () {
          that.changeSelRow();
        }, 500);
      }
    },
    unique1(arr) {
      return Array.from(new Set(arr));
    },
    //初始化选中的行
    changeSelRow: function () {
      for (var i = 0; i < this.datas.length; i++) {
        var id = this.datas[i].gradeId;
        if (this.selectIds.indexOf(id) >= 0) {
          this.$refs.gradeList.toggleRowSelection(this.datas[i], true);
        }
      }
    },
    itemHandleSelectionChange(selection, row) {
      this.classDialogRow=row
      let selected = selection.length && selection.indexOf(row) !== -1;
      if (!this.isMultiple && selected && this.selectIds.length >= this.maxSelectedCount) {
        this.$message({
          message: `最多只能关联${this.maxSelectedCount}个班级`,
          type: "error"
        });
        this.$refs.gradeList.toggleRowSelection(row);
        return false;
      }
      if (selection.length > 0) {
        selection.map(item => {
          let str = item.gradeName
          if (this.selectTimeAry.indexOf(str) === -1) {
            this.selectTimeAry.push(str);
          }
        });
        this.classData = selection[selection.length - 1].gradeName;
      }
      var ids = [];
      let objs = [];
      let obj = [];
      selection.map(org => {
        ids.push(org.gradeId);
        if (this.ExamAndHomeworkCreate) {
          obj = objs.find(o => o.gradeId === org.gradeId) || [];
          if (obj.length == 0) {
            objs.push({
              id: org.gradeId,
              title: org.gradeName,
              students: org.students,
              type: "class"
            });
          }
        } else {
          objs.push({ id: org.gradeId, title: org.gradeName, headTeacherId: org.headTeacherId, headTeacherName: org.headTeacherName });
        }
      });
      this.selectIds = ids;
      this.selectionAll = objs;
      if (this.ExamAndHomeworkCreate) {
        this.$emit("changedCallback", objs, "class");
        return;
      }
      if (this.isRelation || this.isMultiple) {
        if (this.isReturnObj || this.isMultiple) {
          this.$emit("changedCallback", objs, ids);
        } else {
          this.$emit("changedCallback", ids);
        }
      }
    },
    openDialog: function () {
      this.listDialog = true;
      this.getDatas();
      if (this.$refs.gradeList) {
        this.changeSelRow();
      } else {
        this.$nextTick(function () {
          this.changeSelRow();
        });
      }
    },

    cleanSelect() {
      if (this.$refs["gradeList"] !== undefined) {
        this.$refs.gradeList.clearSelection();
        this.selectTimeAry = [];
      }
    },
    selectionClassList(val) {
      if (val.length > 1) {
        return val.length;
      } else if (val.length == 1) {
        return val[0].title || val[0].gradeName;
      } else {
        return "请选择班级";
      }
    },
    // 取消弹窗
    closeDialogClass(){
      this.$emit('closeDialogClass',false)
    },
  }
};
</script>
<style scoped>
*/deep/.el-table__header-wrapper .el-checkbox {
  display: none;
}

@media screen and (max-height: 768px) {
  .dTable .el-table {
    height: 301px !important;
  }
}

.date_List {
  margin-top: 20px;
  margin-left: -70px;
  overflow: hidden;
}

.height {
  height: 100px;
  width: 400px;
  overflow: auto;
}

.tag_list {
  margin-left: 10px;
}

.tag_list .el-tag {
  margin-bottom: 5px;
  display: block;
  margin-right: 20px;
  margin-top: 5px;
}

.relation-btn-nwarp>>>span {
  overflow: hidden;
  width: 167px;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  display: inline-block;
}

.choose_bom {
  margin-top: 10px;
  line-height: 35px;
}
</style>
